import React from 'react';

import TableData from '../components/TableData';

export default function Kapoenen() {
  return (
    <>
      <TableData tak="kapoen" />
    </>
  );
}
